import React from 'react';
import FloatingChat from './FloatingChat';

const ChatProvider: React.FC = () => {
  // Récupérer le token et les infos utilisateur
  const token = localStorage.getItem('token') || '';
  const userStr = localStorage.getItem('currentUser');
  const user = userStr ? JSON.parse(userStr) : null;

  // Ne pas afficher le chat flottant pour les rôles administratifs/support (ils utilisent la page Chat dédiée)
  const isStaff = ['admin', 'super_admin', 'manager', 'agent'].includes(user?.role);
  if (!token || !user || isStaff) {
    return null;
  }

  return (
    <FloatingChat
      token={token}
      userId={user.id.toString()}
      userName={user.name || user.username || 'Admin'}
    />
  );
};

export default ChatProvider;
